module.exports = __webpack_public_path__ + "img/liveNum12.addcb84d.png";